import TeamManagementMenu from './TeamManagementMenu';

export default TeamManagementMenu;
